import React from 'react';
import { CheckIcon, FlowerIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { hero, images, offer } from '../data/content';
export function Hero() {
  return <header id="inicio" className="relative w-full overflow-hidden bg-cream" data-id="element-106" data-mp="9kjxsrx55a59">
      <div className="relative mx-auto grid max-w-content items-center gap-x-14 gap-y-6 px-5 pb-12 pt-7 sm:px-6 lg:grid-cols-[1.05fr_1fr] lg:pb-24 lg:pt-16" data-id="element-107" data-mp="9igxnf29y0mt">
        <div className="text-center lg:col-start-1 lg:row-start-1 lg:self-end lg:text-left" data-id="element-108" data-mp="128607wumu8qj">
          <p className="inline-flex items-center gap-2 font-sans text-[0.7rem] font-semibold uppercase tracking-[0.24em] text-gold-deep sm:text-xs" style={{
          fontSize: "11px"
        }} data-id="element-109" data-mp="xbflpdyh7l78">
            <FlowerIcon className="h-3.5 w-3.5 text-rose" aria-hidden="true" data-id="element-110" data-mp="ncq1vfn0rqoc" />
            {hero.eyebrow}
          </p>

          <h1 className="mx-auto mt-3 max-w-xl font-display text-[2.1rem] font-semibold leading-[1.1] text-brown sm:text-5xl lg:mx-0 lg:text-[3.2rem]" style={{
          fontSize: "33px"
        }} data-id="element-111" data-mp="3d2l8d8tzsyz4">
            Comienza hoy a cultivar las virtudes de una{' '}
            <span className="block pt-1 font-script text-[2.9rem] font-normal leading-[1] text-rose sm:text-6xl lg:text-[4.2rem]" data-id="element-112" data-mp="3j6obhix6kkpk">
              Mujer de Proverbios 31
            </span>
          </h1>

          <p className="mx-auto mt-4 max-w-md font-sans text-[0.95rem] leading-relaxed text-ink-soft sm:text-base lg:mx-0 lg:max-w-lg" data-id="element-113" data-mp="39cpbapgo3b09">
            {hero.subtitle}
          </p>
        </div>

        <div className="relative mx-auto w-full max-w-[440px] lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:max-w-none" data-id="element-114" data-mp="30fy9dwffp1xr">
          <div aria-hidden="true" className="absolute -inset-2 rounded-[30px] border border-gold/40 lg:-inset-3 lg:rounded-b-[36px] lg:rounded-t-[260px]" data-id="element-115" data-mp="2qk3kwkoj4cn2" />
          <img src={images.main} alt={images.mainAlt} className="relative aspect-[5/4] w-full rounded-3xl object-cover object-[50%_45%] shadow-[0_24px_50px_-18px_rgba(104,69,54,0.5)] lg:aspect-square lg:rounded-b-3xl lg:rounded-t-[250px]" data-id="element-116" data-mp="2vjga3c2vhvst" />
        </div>

        <div className="mx-auto w-full max-w-md lg:col-start-1 lg:row-start-2 lg:mx-0 lg:max-w-lg lg:self-start" data-id="element-117" data-mp="s2joa067q6l3">
          

          

          <div className="mt-4" data-id="element-118" data-mp="n9qjjcaquy90">
            <CtaButton href="#todo-incluido" data-id="element-119" data-mp="n9i71lij9uyc">{hero.cta}</CtaButton>
          </div>

          <ul className="mt-3.5 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 lg:justify-start" data-id="element-120" data-mp="ia5j0xfxehu6">
            {hero.checks.map(item => <li key={item} className="inline-flex items-center gap-1 font-sans text-xs font-medium text-ink-soft" data-id="element-121" data-mp="1b1fg54ulm8vr">
                <CheckIcon className="h-3.5 w-3.5 text-rose-deep" aria-hidden="true" data-id="element-122" data-mp="161j7utevbvae" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </header>;
}